export default __webpack_public_path__ + "static/evolution-f835aaf110834aa994176abe0cf5ce6b.png";